import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Repeated “Charts” navigation while already on `/songs` does not remount the component.
 * Emit here so {@link SongChartsComponent} can restore default timeframe, search, sort, and overlays.
 */
@Injectable({ providedIn: 'root' })
export class SongChartsUiService {
  private readonly resetSubject = new Subject<void>();
  readonly reset$ = this.resetSubject.asObservable();

  requestChartsReset(): void {
    this.resetSubject.next();
  }
}
